/** Kaynak kesinliği seviyeleri (v3.1 S9). Etiket ve açıklamalar `acquisition.ts`'te. */
export const ACQUISITION_CERTAINTIES = [
    'platform',
    'click_id',
    'associated',
    'self_reported',
    'unknown',
];
//# sourceMappingURL=acquisition-certainty.js.map